(() => {
  const topicMap = {
    'custom-work': 'Custom piece or commission',
    identification: 'Stone identification',
    polishing: 'Polishing service',
    'wheel-time': 'Wheel time',
    class: 'Class question',
    order: 'Product or order question',
    visit: 'Visit question',
    beaches: 'Beach or treasure hunt question',
    puzzles: 'Puzzle question',
    'makers-choice': "Maker's Choice question",
    artwork: 'Windborn or artwork question',
    other: 'Something else',
  };

  const sourceMap = {
    services: 'Polishing & Services page',
    search: 'Search no-results page',
    'sold-piece': 'Sold product page',
    visit: 'Visit page',
    shop: 'Shop page',
    learn: 'Learn & Explore page',
    classes: 'Classes page',
    puzzles: 'Puzzles page',
    beaches: 'Beaches page',
    story: 'Our Story page',
  };

  const params = new URLSearchParams(window.location.search);

  document.querySelectorAll('[data-northport-contact]').forEach((section) => {
    const topic = section.querySelector('[data-northport-contact-topic]');
    const source = section.querySelector('[data-northport-contact-source]');
    const requestedTopic = topicMap[params.get('topic')];
    const requestedSource = sourceMap[params.get('source')];

    if (topic && requestedTopic && topic.querySelector(`option[value="${requestedTopic}"]`)) {
      topic.value = requestedTopic;
    }

    if (source && requestedSource) {
      source.value = requestedSource;
    }
  });
})();
